import { BaseStateProps } from "data/interface";

export interface ShoppingItem {
  id: number;
  name: string;
  trackingUrl: string;
  imageURL: string;
  cashbackOffer: string;
  shopUrl: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  affiliateUrl: string;
}

export interface ShoppingStateProps extends BaseStateProps {
  isError: boolean;
  shopping: ShoppingItem[];
  fetchedShopping: boolean;
}

export const initialState: ShoppingStateProps = {
  isFetching: false,
  isError: false,
  fetchedShopping: false,
  shopping: [],
};
